<script setup lang="ts">
interface Props {
    href: string;
}

defineProps<Props>();
</script>

<template>
    <a :href="href" target="_blank">
        <slot />
    </a>
</template>

